// extracted by mini-css-extract-plugin
export default {"wrapper":"media-keywords-module--wrapper--utRBO","standard":"media-keywords-module--standard--Hr7pJ","compact":"media-keywords-module--compact--SOvOr"};